import {VEHICLE_ICON} from '../vehicle';

export class PassedPosition {
    public long: number;
    public lat: number;
    public bearing?: number;
    public ts: Date;
    public speed?: number;
    public icon: VEHICLE_ICON = VEHICLE_ICON.Default;
    public isOffRoute: boolean = false;

    get id() {
        return this.ts ? this.ts.toUTCString() : undefined;
    }

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
